import React, { useState, useEffect } from "react";
import { Button, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
//import { Navigation } from "./Navigation";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { OrganizationMemberSelectBox } from "./Component/OrganizationMemberSelectBox";
import MemberDataTable from "./Component/MemberDataTable";
import { MemberInfoEditMode } from "./Component/MemberInfoEditMode";
import { MemberInfoAddMode } from "./Component/MemberInfoAddMode";
import { Grid } from "@mui/material";
import { API_DOMAIN_URL } from "./Common";

export function EditMember() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [organizationUsers, setOrganizationUsers] = useState(null);
  const [orgUser, setOrgUser] = useState();
  const [ownedMembers, setOwnedMembers] = useState();
  const [membersLoading, setMembersLoading] = useState(false);
  const [ownedGroups, setOwnedGroups] = useState(null);
  const [ownedMemberGroups, setOwnedMemberGroups] = useState([]);
  const [filterGroup, setFilterGroup] = useState("ALL");
  const [targetMember, setTargetMember] = useState();
  const [displayMode, setDisplayMode] = useState(2); // 0: 新規追加、1: 編集、削除, 2: 非表示
  const [showAddBtn, setShowAddBtn] = useState(false);

  useEffect(() => {
    if (orgUser && orgUser.id) {
      getOwnedMembers(orgUser);
      getOwnedGroups(orgUser);
      getOwnedMemberGroups(orgUser);
      setFilterGroup("ALL");
    }
  }, [orgUser]);

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  const getOrganizationUsers = () => {
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetOrganizationUsers?code=${code}&UserId=${user.id}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setOrganizationUsers(response);
      })
      .catch(() => {
        console.log("EditMember OrganizationUsers Exception");
        let orgUsers = [];
        orgUsers.push(user);
        setOrganizationUsers(orgUsers);
      });
  };

  const getOwnedMembers = (orgUser) => {
    setMembersLoading(true);
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedMembers?code=${code}&UserId=${orgUser.id}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        response.push(orgUser);
        setOwnedMembers(response);
        setMembersLoading(false);
      })
      .catch(() => {
        setOwnedMembers([orgUser]);
        setMembersLoading(false);
      });
  };

  const getOwnedGroups = (orgUser) => {
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedGroups?code=${code}&UserId=${orgUser.id}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setOwnedGroups(response);
      })
      .catch(() => {
        setOwnedGroups([]);
      });
  };

  const getOwnedMemberGroups = (orgUser) => {
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetUserGroupBelongings?code=${code}&UserId=${orgUser.id}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setOwnedMemberGroups(response);
      })
      .catch(() => {
        setOwnedMemberGroups([]);
      });
  };

  const getFilteredMembers = () => {
    if (!ownedMembers) return undefined;
    if (filterGroup === "ALL") return ownedMembers;
    const memberIdsInGroup = ownedMemberGroups
      .filter((omg) => omg.GroupId === filterGroup.id)
      .map((omg) => omg.UserId);
    return ownedMembers.filter((m) => memberIdsInGroup.includes(m.id));
  };

  const getMemberInfoForSpecificMode = (val, updateMembers) => {
    if (val == 0) {
      return (
        <MemberInfoAddMode
          orgUser={orgUser}
          updateOwnedMembers={updateMembers}
          setDisplayMode={setDisplayMode}
        />
      );
    } else if (val == 1) {
      return (
        <MemberInfoEditMode
          key={targetMember?.id}
          member={targetMember}
          orgUser={orgUser}
          setDisplayMode={setDisplayMode}
          updateOwnedMembers={updateMembers}
        />
      );
    } else if (val == 2) {
      return <></>;
    }
  };

  useEffect(() => {
    if (authCheck()) {
      getOrganizationUsers();
    }
  }, []);

  const clickedEvent = () => {
    console.log("start add mode");
    setDisplayMode(0);
  };

  // 組織内のメンバー群を更新する
  const updateOwnedMembers = () => {
    getOwnedMembers(orgUser);
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography component="h1" variant="h5">
                メンバー編集
              </Typography>
            </Grid>
            <Grid item md={8}></Grid>

            <Grid item md={3} mt={1}>
              <OrganizationMemberSelectBox
                orgUsers={organizationUsers}
                setOrgUser={setOrgUser}
                setShowAddBtn={setShowAddBtn}
              />
            </Grid>
            <Grid item md={9} mt={1}></Grid>

            {orgUser && (
              <>
                <Grid item xs={12} mt={1}>
                  <FormControl sx={{ m: 1, minWidth: 200, maxWidth: 500 }} size="small">
                    <InputLabel id="filter-group-label">
                      {ownedGroups === null ? "読み込み中..." : "グループで絞込"}
                    </InputLabel>
                    <Select
                      labelId="filter-group-label"
                      label="グループで絞込"
                      value={filterGroup === "ALL" ? "ALL" : filterGroup?.id || "ALL"}
                      disabled={ownedGroups === null}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === "ALL") {
                          setFilterGroup("ALL");
                        } else {
                          const grp = ownedGroups.find((g) => g.id === val);
                          setFilterGroup(grp || "ALL");
                        }
                      }}
                    >
                      <MenuItem value="ALL">全て</MenuItem>
                      {ownedGroups && ownedGroups.map((group, i) => (
                        <MenuItem value={group.id} key={i}>{group.Name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </>
            )}
          </Grid>

          <Grid container justify="flex-end" mb={1}>
            {showAddBtn == true ? (
              <>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mt: 2 }}
                  align
                  onClick={clickedEvent}
                >
                  新規追加
                </Button>
              </>
            ) : (
              ""
            )}
          </Grid>
          <MemberDataTable
            ownedMembers={getFilteredMembers()}
            setDisplayMode={setDisplayMode}
            setTargetMember={setTargetMember}
            loading={membersLoading}
          />
          <Box sx={{ mb: 4 }} />

          {getMemberInfoForSpecificMode(displayMode, updateOwnedMembers)}
        </Box>
      </Container>
    </div>
  );
}
